import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/ats/Desktop/cartoon-mango/docz-app-with-algolia-search/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "data-handler"
    }}>{`Data Handler`}</h1>
    <h2 {...{
      "id": "-data-handler-without-filter"
    }}>{`# Data Handler without filter`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import { HOC, commonConstants, store } from "react-boilerplate-redux-saga-hoc";

const { ON_SUCCESS } = commonConstants;
const { DEMO_API_CONFIGURATION_CUSTOM_TASK } = props;

DEMO_API_CONFIGURATION_CUSTOM_TASK(ON_SUCCESS, {
  task: {
    name: "Data-Handler",
  },
});
`}</code></pre>
    <h2 {...{
      "id": "-data-handler-with-filter"
    }}>{`# Data Handler with filter`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import { HOC, commonConstants, store } from "react-boilerplate-redux-saga-hoc";

const { ON_SUCCESS } = commonConstants;
const { DEMO_API_CONFIGURATION_CUSTOM_TASK } = props;

DEMO_API_CONFIGURATION_CUSTOM_TASK(ON_SUCCESS, {
  task: {
    name: "Data-Handler",
  },
  filter: ["name"],
});
`}</code></pre>
    <h2 {...{
      "id": "-data-handler-with-multi-filter"
    }}>{`# Data Handler with Multi-filter`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import { HOC, commonConstants, store } from "react-boilerplate-redux-saga-hoc";

const { ON_SUCCESS } = commonConstants;
const { DEMO_API_CONFIGURATION_CUSTOM_TASK } = props;

DEMO_API_CONFIGURATION_CUSTOM_TASK(ON_SUCCESS, {
  task: {
    name: "Data-Handler",
  },
  filter: [["filter-1"], ["filter-2"], ["filter-2"]],
});
`}</code></pre>
    <h2 {...{
      "id": "-things-to-remember"
    }}>{`# Things to Remember`}</h2>
    <pre><code parentName="pre" {...{}}>{` -Adding multiple filters will create multiple copy of the same data.
-It will helps to handle different types of data in same api..such as variable kind of filters.

 Note:
 -Data-handler is default handler.
 -No need specify the handler if you want to execute a data  handler task.
`}</code></pre>
    <h2 {...{
      "id": "-data-handler-function---api"
    }}>{`# Data Handler Function - Api`}</h2>
    <pre><code parentName="pre" {...{}}>{`    Important:
- The code below are the built in handler function.
- Don't copy and paste this handler, it is already available with this hoc.
- You will learn how to create your own custom handler in below.
- If you want to customize this handler you can do it.
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import {
  generateTimeStamp,
  updateIn,
  getIn,
  Safe,
} from "react-boilerplate-redux-saga-hoc";

const _checkIsNotObject = (data) =>
  Object.prototype.toString.call(data) !== "[object Object]";

export const dataHandler = ({
  task: { clearData, subKey = [] } = {},
  callback: { updateCallback } = {},
  successData = {},
}) => ({ data: oldData = {} } = {}) => ({
  data: (() => {
    if (subKey.length > 0) {
      const _oldCopyData = {
        ...oldData,
        ...successData,
        [subKey[0]]: oldData[subKey[0]],
      };
      return updateIn(_oldCopyData, subKey, (_oldData) => {
        if (clearData) return Safe(successData, \`.\${subKey.join(".")}\`);
        return updateCallback
          ? updateCallback(_oldData, Safe(successData, \`.\${subKey.join(".")}\`))
          : _checkIsNotObject(Safe(successData, \`.\${subKey.join(".")}\`)) ||
            _checkIsNotObject(Safe(_oldData, \`.\${subKey.join(".")}\`))
          ? Safe(successData, \`.\${subKey.join(".")}\`)
          : newObject(_oldData, Safe(successData, \`.\${subKey.join(".")}\`));
      });
    }
    return updateCallback
      ? updateCallback(oldData, successData)
      : _checkIsNotObject(successData) ||
        _checkIsNotObject(oldData) ||
        clearData
      ? successData
      : newObject(oldData, successData);
  })(),
  error: false,
  lastUpdated: generateTimeStamp(),
  isInfinite: undefined,
  infiniteEnd: undefined,
  isError: false,
});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      